import { intersectRoles } from './../helpers/auth-helpers'
import { IUser } from './../../common/types/User'
import { TipoSanguineo } from 'common/types/TipoSanguineo'
import { Paramaconico } from 'common/types/FilhoMacon'
import Irmao, { InputIrmao, Esposa } from 'common/types/Irmao'
import { éCargoAdminDeLoja } from './../../common/shareds/utils'

export function criarIrmao(usuarioAtual: Irmao): InputIrmao {
	return {
		nomeCompleto: '',
		cim: '',
		senha: '',
		grauMacon: 'Aprendiz',
		cargoDeAdminDaLoja: '',
		cargoDeAdminDaPotencia: '',
		situacaoDoMacon: 'Regular',
		telefones: [],
		loja: usuarioAtual.loja._id || null,
		lojas: [],
		potencia: usuarioAtual.potencia._id || null,
		profissao: '',
		cargo: '',
		hobbie: '',
		somar: usuarioAtual.somar?._id || null,
		foto: undefined,
		esposa: null,
		filhos: [],
		secretarioDeInformatica: false,
		revalidarPalavraSemestral: false,
	}
}

export function criarEsposa(): Esposa {
	return {
		nome: '',
		profissao: '',
	}
}

export const adminIrmaoGuard = (irmao: Irmao) => (usuario: IUser | null) => {
	if (!usuario || usuario.role === 'Visitante') return false
	return (
		irmao._id === usuario._id ||
		intersectRoles(usuario.role, 'admin') ||
		(usuario.potencia._id === irmao.potencia._id && intersectRoles(usuario.role, 'admin-potencia')) ||
		(usuario.loja._id === irmao.loja._id && éCargoAdminDeLoja(usuario.cargoDeAdminDaLoja, usuario.secretarioDeInformatica))) ||
		(usuario.lojas.some(loja => loja.loja._id === irmao.loja._id && éCargoAdminDeLoja(loja.cargoDeAdminDaLoja))
	)
}

export const paramaconicos = [
	'Demolay',
	'Escudeiro',
	'Abelhinha',
	'Filha de Jo',
	'Maçom',
] as Paramaconico[]

export const tiposSanguineos = [
	'O-',
	'O+',
	'B-',
	'B+',
	'A-',
	'A+',
	'AB-',
	'AB+',
] as TipoSanguineo[]
